import './components/header.js';
import './components/notice-bar.js';
import './components/navigation-megamenu.js';
import createNavMobile from './components/navigation-mobile.js';
import Accordion from './components/accordion.js';
import './sections/footer-promo.js';
import './sections/collection-carousel.js';
import './sections/video-player.js';
import './sections/story-carousel.js';
import './sections/footer-newsletter-signup.js';
import './sections/newsletter-signup.js';
import './sections/blog-carousel.js';
import './sections/blog-post.js';
import './sections/blog-template.js';
import './sections/cart-page.js';
import './sections/star-notes-carousel.js';
import './sections/product-carousel.js';
import './sections/product-gallery.js';
import './sections/product-info-carousel.js';
import './templates/template-customer.js';
import './components/drawers/drawer.js';
import createOverlay from './components/page-overlay.js';
import './sections/cart-drawer.js';
import './components/remove-item.js';
import './sections/positivity-luxury-carousel.js';
import './components/customLoyaltyButton.js';

document.addEventListener('DOMContentLoaded', () => {
  createNavMobile();

  // Set up accordions
  [...document.querySelectorAll('[data-accordion]')].forEach(
    accordion => new Accordion(accordion)
  );

  // Set up scroll-to-able sections
  [...document.querySelectorAll('a[href^="#"]')]
    .filter(anchor => anchor.href !== '#')
    .forEach(anchor => {
      const sectionIdentifier = anchor.getAttribute('href').replace('#', '');
      const linkableSection = document.querySelector(
        `[data-scroll-linkable="${sectionIdentifier}"]`
      );

      if (!linkableSection) {
        return;
      }

      anchor.addEventListener('click', e => {
        e.preventDefault();
        linkableSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

  createOverlay(document.querySelector('[data-page-overlay]'));
});
